module.exports = __webpack_public_path__ + "img/bahama.5b13cf7a.png";